'use client';

import {useCasesContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderLight, sectionPadding, SectionContainer, SectionHeader} from './shared';

export function UseCasesSection() {
  return (
    <section id={useCasesContent.id} aria-labelledby="use-cases-heading" className={`${sectionPadding} bg-kobra-bg ${sectionBorderLight} relative`}>
      <SectionContainer>
        <FadeIn>
          <SectionHeader badge="Casos de uso" title={useCasesContent.title} description={useCasesContent.description} />
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-x-8 gap-y-10">
          {useCasesContent.cases.map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <FadeIn key={useCase.title} delay={index * 0.1} className="h-full">
                <article className={`flex gap-4 p-4 rounded-2xl border border-transparent hover:border-kobra-border hover:bg-white/80 ${cardHoverClass}`}>
                  <div className="shrink-0 w-12 h-12 bg-white border border-kobra-border rounded-xl flex items-center justify-center text-kobra-text-dark">
                    <Icon className="w-5 h-5" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-kobra-text-dark mb-2">{useCase.title}</h3>
                    <p className="text-kobra-text-muted leading-relaxed text-sm">{useCase.description}</p>
                  </div>
                </article>
              </FadeIn>
            );
          })}
        </div>
      </SectionContainer>
    </section>
  );
}
